import { Document, Page, StyleSheet, View, Text } from "@react-pdf/renderer";
import { getDatesArrByMonth, getDayNameByDate } from "utils/attendanceUtility";

// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    paddingBottom: 2,
    borderBottomWidth: 2,
    marginBottom: 5,
  },
  // Users Styles
  userDataContainer: {
    width: "95%",
    margin: "0 auto",
    marginBottom: 10,
    gap: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "start",
  },

  userRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
  },

  userSubRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 30,
  },

  userHeadingMain: {
    fontSize: 15,
    fontWeight: "extrabold",
    marginBottom: 2,
  },

  userHeading: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
  },

  userBody: {
    fontSize: 10,
    fontWeight: "semibold",
    textAlign: "right",
  },
  tableContainer: {
    width: "100%",
    borderStyle: "solid",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    fontSize: 12,
    width: "14%",
    height: 19,
    fontWeight: "extrabold",
    textAlign: "center",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
  },
  tableCol: {
    fontSize: 9,
    width: "14%",
    height: 19,
    textAlign: "center",
    borderStyle: "solid",
    justifyContent: "center",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    fontSize: 12,
    padding: 1,
    height: 19,
    paddingLeft: 18,
    borderLeftWidth: 1,
    textAlign: "left",
    fontWeight: "bold",
  },
  tableCell: {
    fontSize: 9,
    height: 19,
    textAlign: "center",
  },
  tableFirstCol: {
    fontSize: 9,
    width: "12.5%",
    borderStyle: "solid",
    borderWidth: 1,
    height: 19,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#d3d3d3",
    textAlign: "left",
  },

  // Summary
  summaryContainer: {
    width: "100%",
    marginTop: 10,
    border: "2px solid #000",
  },
});

// Create Document Component
export const AttendanceReport = ({ selectedReport }) => {
  /*   All Functions   ********************************************* */

  // Create a function to convert "18:11:56" to "6:11 PM"
  function formatTime(timeString) {
    if (!timeString && timeString !== 0) {
      return "-";
    }

    // Normalize to string to avoid crashes when a number/null leaks through
    const normalized = String(timeString);
    const parts = normalized.split(":");
    if (parts.length < 2) {
      return normalized || "-";
    }

    let [hours, minutes] = parts.map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return normalized || "-";
    }

    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Handle midnight (0) and 12 PM
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${period}`;
  }

  /*   All UseEffects   ********************************************* */
  const DatesList = getDatesArrByMonth(selectedReport?.monthYear);

  let headings = [
    "Date",
    "In Time",
    "Out Time",
    "Late Time",
    "Over Time",
    "Total Hours",
  ];

  console.log("selected report in pdf:", selectedReport);

  return (
    <Document title={"Attendance Report"}>
      <Page style={styles.page}>
        <View style={styles.title}>
          <Text>Pay Period Timecard Report</Text>
        </View>
        {/* User Data */}
        <View style={styles.userDataContainer}>
          <View style={{ width: "40%" }}>
            <Text style={[styles.userHeadingMain, { marginBottom: 5 }]}>
              {selectedReport?.userData.name}
            </Text>

            <View style={styles.userSubRow}>
              <Text style={styles.userHeading}>Employee ID:</Text>
              <Text style={styles.userBody}>
                {selectedReport?.userData?.userId}
              </Text>
            </View>
          </View>

          <View style={{ width: "40%" }}>
            <Text style={[styles.userHeadingMain, { marginBottom: 5 }]}>
              {DatesList[0]} To {DatesList.slice(-1)}
            </Text>
            <View style={styles.userRow}>
              <Text style={styles.userHeading}>Badge No</Text>
              <Text style={styles.userBody}>
                {selectedReport?.userData.badgeNo}
              </Text>
            </View>
          </View>
        </View>

        {/* Attendance Records */}
        <View style={[styles.tableContainer]}>
          <View style={styles.tableRow}>
            {headings?.map((heading, i) => (
              <View
                key={heading}
                style={[
                  styles.tableColHeader,
                  {
                    borderLeftWidth: i === 0 ? 1 : 0,
                    width: i === 0 ? "30%" : "14%",
                  },
                ]}
              >
                <Text style={styles.tableCellHeader}>{heading}</Text>
              </View>
            ))}
          </View>
        </View>
        <View style={styles.tableContainer}>
          {DatesList.map((date, index) => (
            <View
              key={index}
              style={[
                styles.tableRow,
                {
                  backgroundColor:
                    getDayNameByDate(date) === "Sunday" && "#d3d3d3",
                },
              ]}
            >
              <View style={[styles.tableCol, { width: "30%" }]}>
                <Text style={[styles.tableCellHeader]}>
                  {date} ({" "}
                  {selectedReport?.attendanceRecords[date]?.dayNameOfWeek ?
                    selectedReport?.attendanceRecords[date]?.dayNameOfWeek
                  : getDayNameByDate(date)}{" "}
                  )
                  <Text style={{ fontStyle: "italic", color: "red" }}>
                    {selectedReport?.attendanceRecords[date]?.type ===
                      "Holiday" && " (H)"}
                  </Text>
                </Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  {
                    backgroundColor:
                      selectedReport?.attendanceRecords[date]?.inTime &&
                      selectedReport?.attendanceRecords[date]?.inTime ===
                        selectedReport?.attendanceRecords[date]?.outTime &&
                      "#f1aeb5",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.tableCell,
                    {
                      color:
                        (
                          selectedReport?.attendanceRecords[date]?.message ===
                          "Absent"
                        ) ?
                          "red"
                        : (
                          selectedReport?.attendanceRecords[date]?.type ===
                          "Holiday"
                        ) ?
                          "green"
                        : "black",
                    },
                  ]}
                >
                  {(
                    selectedReport?.attendanceRecords[date]?.message ===
                    "Absent"
                  ) ?
                    "Absent"
                  : formatTime(
                      selectedReport?.attendanceRecords[date]?.inTime,
                    ) || "-"
                  }
                </Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  {
                    backgroundColor:
                      selectedReport?.attendanceRecords[date]?.inTime &&
                      selectedReport?.attendanceRecords[date]?.inTime ===
                        selectedReport?.attendanceRecords[date]?.outTime &&
                      "#f1aeb5",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.tableCell,
                    {
                      color:
                        (
                          selectedReport?.attendanceRecords[date]?.message ===
                          "Absent"
                        ) ?
                          "red"
                        : (
                          selectedReport?.attendanceRecords[date]?.type ===
                          "Holiday"
                        ) ?
                          "green"
                        : "black",
                    },
                  ]}
                >
                  {(
                    selectedReport?.attendanceRecords[date]?.message ===
                    "Absent"
                  ) ?
                    "Absent"
                  : formatTime(
                      selectedReport?.attendanceRecords[date]?.outTime,
                    ) || "-"
                  }
                </Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  {
                    backgroundColor:
                      selectedReport?.attendanceRecords[date]?.inTime &&
                      selectedReport?.attendanceRecords[date]?.inTime ===
                        selectedReport?.attendanceRecords[date]?.outTime &&
                      "#f1aeb5",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.tableCell,
                    {
                      color:
                        (
                          selectedReport?.attendanceRecords[date]?.message ===
                          "Absent"
                        ) ?
                          "red"
                        : (
                          selectedReport?.attendanceRecords[date]?.type ===
                          "Holiday"
                        ) ?
                          "green"
                        : "black",
                    },
                  ]}
                >
                  {(
                    selectedReport?.attendanceRecords[date]?.message ===
                    "Absent"
                  ) ?
                    "Absent"
                  : selectedReport?.attendanceRecords[date]?.totalLateTime ||
                    "-"
                  }
                </Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  {
                    backgroundColor:
                      selectedReport?.attendanceRecords[date]?.inTime &&
                      selectedReport?.attendanceRecords[date]?.inTime ===
                        selectedReport?.attendanceRecords[date]?.outTime &&
                      "#f1aeb5",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.tableCell,
                    {
                      color:
                        selectedReport?.attendanceRecords[date]?.message ===
                          "Absent" && "red",
                    },
                  ]}
                >
                  {(
                    selectedReport?.attendanceRecords[date]?.message ===
                    "Absent"
                  ) ?
                    "Absent"
                  : selectedReport?.attendanceRecords[date]?.overTime || "-"}
                </Text>
              </View>
              <View
                style={[
                  styles.tableCol,
                  {
                    backgroundColor:
                      selectedReport?.attendanceRecords[date]?.inTime &&
                      selectedReport?.attendanceRecords[date]?.inTime ===
                        selectedReport?.attendanceRecords[date]?.outTime &&
                      "#f1aeb5",
                  },
                ]}
              >
                <Text
                  style={[
                    styles.tableCell,
                    {
                      color:
                        selectedReport?.attendanceRecords[date]?.message ===
                          "Absent" && "red",
                    },
                  ]}
                >
                  {(
                    selectedReport?.attendanceRecords[date]?.message ===
                    "Absent"
                  ) ?
                    "Absent"
                  : selectedReport?.attendanceRecords[date]?.totalHours || "-"}
                </Text>
              </View>
            </View>
          ))}
        </View>
        <View>
          <View style={styles.summaryContainer}>
            {/* Layout with 2 columns*/}

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: 10,
                paddingVertical: 5,
              }}
            >
              <View style={{ width: "50%" }}>
                <Text style={styles.userHeading}>Total Late Time</Text>
              </View>
              <View style={{ width: "50%" }}>
                <Text style={styles.userBody}>
                  {selectedReport?.summaryData?.totalLateTime || "00:00"}
                </Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: 10,
                paddingVertical: 5,
              }}
            >
              <View style={{ width: "50%" }}>
                <Text style={styles.userHeading}>Absent Days</Text>
              </View>
              <View style={{ width: "50%" }}>
                <Text style={styles.userBody}>
                  {selectedReport?.summaryData?.absentDaysCount || 0}
                </Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: 10,
                paddingVertical: 5,
              }}
            >
              <View style={{ width: "50%" }}>
                <Text style={styles.userHeading}>Total Over Time</Text>
              </View>
              <View style={{ width: "50%" }}>
                <Text style={styles.userBody}>
                  {selectedReport?.summaryData?.totalOverTime || "00:00"}
                </Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                paddingHorizontal: 10,
                paddingVertical: 5,
              }}
            >
              <View style={{ width: "50%" }}>
                <Text style={styles.userHeading}>Total Working Hours</Text>
              </View>
              <View style={{ width: "50%" }}>
                <Text style={styles.userBody}>
                  {selectedReport?.summaryData?.totalWorkingHours || "00:00"}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
